import LoadingCircle from "../components/ui/LoadingCircle";

export default function LoadingScreen() {
    return <div className="fixed w-screen h-screen z-50 bg-black opacity-50 flex justify-center items-center">
        <LoadingCircle/>
    </div>
}